import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

interface PageFiltersState {
  businessZones: number[];
  financialTrends: number[];
  analyticsReports: number[];
  businessPlanning: number[];
  repeatsAndReferrers: number[];
}

const initialState: PageFiltersState = {
  businessZones: [],
  financialTrends: [],
  analyticsReports: [],
  businessPlanning: [],
  repeatsAndReferrers: [],
};

const pageFiltersSlice = createSlice({
  name: "pageFilters",
  initialState,
  reducers: {
    setPageFilter: (
      state,
      action: PayloadAction<{ pageKey: keyof PageFiltersState; ids: number[] }>,
    ) => {
      state[action.payload.pageKey] = action.payload.ids;
    },
    clearPageFilter: (state, action: PayloadAction<keyof PageFiltersState>) => {
      state[action.payload] = [];
    },
    clearAllPageFilters: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    // Clear all page filters on logout/purge
    builder.addCase(PURGE, () => initialState);
  },
});

export const { setPageFilter, clearPageFilter, clearAllPageFilters } =
  pageFiltersSlice.actions;

export default pageFiltersSlice.reducer;
